import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { IoMdArrowBack } from "react-icons/io";
import { withTranslation } from "react-i18next";
import { Signup, ClearState } from "../../actions/productActions";
import PopUp from "../Modals/Popup";
import SignupComplete from "./SignupComplete";
import { checkEmail, clearUserState, signup, tempSignupData } from "../../actions/userActions";
import close from "../../assets/svgs/close.svg";
import warley from "../../assets/svgs/warley.svg";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import "../../assets/css/form.css";
import "../../assets/css/component.css";
import "./signup.css";
import "../../assets/css/modal.css";
import { loginUser } from "../../actions/authActions";
import { IoEye, IoEyeOff } from "react-icons/io5"; 

const Signup2 = (props) => {
  const [showPass, setShowPass] = useState(false); 
  const [showConfirmPass, setShowConfirmPass] = useState(false); 
  const { register, reset, handleSubmit } = useForm();
  const [canSubmit, setSubmitState] = useState(false);
  const [load, setLoad] = useState(false);
  const [lshow, setLshow] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [emailStatus, setEmailStatus] = useState("ERROR");
  const [emailText, setEmailText] = useState("");
  const emailInputElement = useRef(null);
  const [accountSuccess, setShowModal] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userSignUp, setUserSignUp] = useState();

  useEffect(() => {
    if (props.signup && !props.loading && props.signup.success && load) {
      console.log("____Not Errors______");
      setLoad(false);
      localStorage.removeItem('cart');
      setPopupText("Registration Successfully!");
      setLshow(true);
      reset();
      //props.closeModal();
      props.ClearState();
    } else if (props.errors && load) {
      alert(JSON.stringify(props.errors.data));
      setLoad(false);
      props.ClearState();
    }
  }, [load, props]);

  useEffect(() => { //USED TO CHECK IF EMAIL INPUT ELEMENT HAS CHANGED
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setSubmitState(false)
    setEmailStatus("")
    props.clearUserState()
    if (emailRegex.test(String(emailText).toLowerCase())) {
      setEmailStatus(<div className="footer-warley-description text-dark">Loading</div>)
      props.checkEmail(emailText) //SEND THE REQUEST TO CHECK EMAIL
    }
  }, [emailText])

  useEffect(() => { //USED TO CHECK IF SIGNUP WAS SUCCESSFUL
    if (props?.user?.signup?.data?.success) {
      setShowModal(true);
      props.clearUserState();
    }
  }, [props.user.signup]);


  useEffect(() => { // USED TO UPDATE ERROR/SUCCESS MESSAGE FOR EMAIL
    if (props.user.email === true) {
      setEmailStatus(<div className="footer-warley-description text-success">Email Available</div>)
    } else if (props.user.email === false) {
      setEmailStatus(<div className="footer-warley-description text-danger">Email already Exist</div>)
    }
  }, [props.user.email])

  //signup
  const onSubmit = (data) => {
    if (data.password !== data.confirm_password) {
      setConfirmPassword("Password must be the same");
      return;
    }

    let newData = {
      ...props.signupVal,
      ...data,
      email: emailInputElement.current.value,
      password: data.password,
      confirm_password: data.confirm_password,
      location_id: props.location_id || localStorage.location_id,
      business_id: props.business_id || localStorage.business_id,
      username: props.signupVal.first_name
    };

    props.setSignup(newData);
    props.tempSignupData(newData);
    props.signup(newData); // SEND REQUEST TO SIGN UP
  };

  useEffect(() => {
    if (props?.user?.signup?.data?.success) {
      props.closeModal();
    } else if (props?.user?.signup?.data?.message) {
      toast.error(props.user.signup.data.message);
    }
  }, [props?.user?.signup]);


  const closeModal = () => {
    props.closeModal();
    setLshow(false);
  };

  if (document.querySelector("#signUpButton")) { //Check if not null
    if (!props.user?.email || props.user?.checkEmailLoading) {
      document.querySelector("#signUpButton").style.opacity = 0.5
      document.querySelector("#signUpButton").disabled = true
    } else {
      document.querySelector("#signUpButton").style.opacity = 1.0
      document.querySelector("#signUpButton").disabled = false
    }
  }

  const handleBack = () => {
    props.previousStep();
  }

  useEffect(() => {
    if (props.signup_login) {
      const userData = {
        email: props?.signup_login?.data?.user?.email,
        password: props?.tempSignupResults?.password || "test123",
        platform: "Food-Delivery",
        business_id: props?.business_id || localStorage.business_id,
        username: props?.auth?.username
      }
      props.loginUser(userData, true, "register");
    }

  }, [props.signup_login]);

 return (
    <>
      <SignupComplete
        joinus={props.joinus}
        location_id={props.location_id}
        business_id={props.business_id}
        show={accountSuccess}
        closeModal={() => { setShowModal(false) }}
        signup_login={userSignUp?.data}
        user_name={props.auth.username}
      />
      <Modal
        show={props.show}
        onHide={props.joinus ? () => { } : props.closeModal}
        dialogClassName="s2-dialog"
        contentClassName="s2-content"
        centered
      >
        <PopUp text={popupText} show={lshow} closeModal={closeModal} />
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body className="s2-body">
            {/* Top bar: back + close */}
            <div className="s2-topbar">
              <button type="button" className="s2-icon-btn" onClick={handleBack} aria-label="Back">
                <IoMdArrowBack size={22} />
              </button>
              <ModalCloseButton
                onClick={() => { props.joinus ? props.setSignupClose(1) : props.closeModal(); }}
                style={{ position: 'static', width: '32px', height: '32px' }}
              />
            </div>

            <div className="s2-logo-wrap">
              <img src={warley} width="220" height="46" alt="warley" />
            </div>
            <div className="s2-title">Sign up for WARELY account</div>

            {/* Email */}
            <div className="s2-field">
              <label className="s2-label">Email</label>
              <input
                type="email"
                ref={emailInputElement}
                className="s2-input"
                required
                autoComplete="off"
                placeholder="Enter your email"
                onChange={() => setEmailText(emailInputElement.current.value)}
              />
              {emailStatus && <div className="s2-email-status">{emailStatus}</div>}
            </div>

            {/* Password */}
            <div className="s2-field">
              <label className="s2-label">Password</label>
              <div className="s2-pw-wrap">
                <input
                  required
                  minLength="7"
                  autoComplete="off"
                  placeholder="Enter password"
                  {...register("password")}
                  type={showPass ? "text" : "password"}
                  className="s2-input"
                />
                <button type="button" className="s2-pw-eye" onClick={() => setShowPass(!showPass)}>
                  {showPass ? <IoEye size={20} /> : <IoEyeOff size={20} />}
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div className="s2-field">
              <label className="s2-label">Confirm Password</label>
              <div className="s2-pw-wrap">
                <input
                  required
                  minLength="7"
                  autoComplete="off"
                  placeholder="Re-enter password"
                  {...register("confirm_password")}
                  type={showConfirmPass ? "text" : "password"}
                  className="s2-input"
                />
                <button type="button" className="s2-pw-eye" onClick={() => setShowConfirmPass(!showConfirmPass)}>
                  {showConfirmPass ? <IoEye size={20} /> : <IoEyeOff size={20} />}
                </button>
              </div>
              {confirmPassword && <div className="s2-error">{confirmPassword}</div>}
            </div>

            {/* Terms */}
            <div className="s2-terms">
              By signing up, you have read and agreed to our&nbsp;
              <a href="/terms-and-condition" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
              &nbsp;and&nbsp;
              <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
            </div>
          </Modal.Body>

          <Modal.Footer className="s2-modal-footer">
            <button
              type="submit"
              className="s2-submit-btn"
              style={{ opacity: canSubmit ? 1.0 : 0.5 }}
              id="signUpButton"
            >
              Sign up
            </button>
            <div className="s2-powered">Powered by Warely</div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
Signup2.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  signup: state?.products?.signup,
  loading: state?.products?.loading,
  auth: state?.auth,
  errors: state?.products?.errors,
  user: state?.user,
  signup_login: state?.user?.signup,
  tempSignupResults: state?.user?.tempSignup
});

export default withTranslation()(
  connect(mapStateToProps, { Signup, ClearState, checkEmail, clearUserState, signup, loginUser, tempSignupData })(Signup2)
);
